import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { CustomTransactionTableValues } from "./CustomTypography";

function CustomHierarchyTable({ columns, data, onRowClick }) {
  return (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: "4px",
        boxShadow: "none",
        overflowY: "scroll",
        height: "100%",
      }}
    >
      <Table>
        <TableHead style={{ backgroundColor: "#FEDC85" }}>
          <TableRow>
            {columns.map((column, index) => (
              <TableCell
                key={index}
                align={column.align || "left"}
                style={{ padding: "6px 10px" }}
              >
                <CustomTransactionTableValues>
                  {column.label}
                </CustomTransactionTableValues>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow
              key={rowIndex}
              sx={{
                backgroundColor: rowIndex % 2 !== 0 ? "#EFEFEF" : "inherit",
                cursor: "pointer",
              }}
              onClick={() => onRowClick(row)}
            >
              {columns.map((column, colIndex) => (
                <TableCell
                  key={colIndex}
                  align={column.align || "left"}
                  style={{
                    padding: "4px 10px",
                    border: "none",
                  }}
                >
                  <CustomTransactionTableValues>
                    {row[column.field]}
                  </CustomTransactionTableValues>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default CustomHierarchyTable;
